import MainLayout from 'layout/mainLayout';
import { InfiniteRoadmapByKeyword } from 'pages/main/searchByKeyword/InfiniteRoadmaps';

export default function KeywordSearchRoadmaps() {
  return (
    <MainLayout>
      <InfiniteRoadmapByKeyword />
    </MainLayout>
  );
}
